const tooltips = {
    no_mic_m:
        <div>
            <div>{"היי, נראה שהרמקול לא עובד במחשב,"}</div>
            <div>{"תבקש מהמורה לבדוק ואחר כך תלחץ על הכפתור הכתום."}</div>
        </div>,
    no_mic_f:
        <div>
            <div>{"היי, נראה שהרמקול לא עובד במחשב,"}</div>
            <div>{"תבקשי מהמורה לבדוק ואחר כך תלחצי על הכפתור הכתום."}</div>
        </div>,
    start_m:
        <div>
            {"הי 👋"}
            <div>{" יש לנו היום כמה משימות בקריאה, "}</div>
            <div>{"כשאתה מוכן לצאת לדרך תלחץ על הכפתור הכתום."}</div>
        </div>,
    start_f: <div>
        {"הי 👋"}
        <div>  {" יש לנו היום כמה משימות בקריאה, "}</div>
        <div>{"כשאת מוכנה לצאת לדרך תלחצי על הכפתור הכתום."}</div>
    </div>,
    other_start_m:
        <div>
            {"עכשיו למשימה הבאה ."}
            <div>{"מתקדמים תמיד עם הכפתור הכתום."}</div>
        </div>,
    other_start_f:
        <div>
            {"עכשיו למשימה הבאה ."}
            <div>{"מתקדמים תמיד עם הכפתור הכתום."}</div>
        </div>,
    words_exam_f:
        <div>
            {"במשימה הזו קוראים רשימת מילים."}
            <div>{"את המילים קוראים בטורים מלמעלה ללמטה כמו בהדגמה,"}</div>
            <div>{"הבנת?"}</div>
            <div>{"תלחצי על הכפתור הכתום להתחיל במשימה"}</div>
        </div>,
    words_exam_m:
        <div>
            {"במשימה הזו קוראים רשימת מילים."}
            <div>{"את המילים קוראים בטורים מלמעלה ללמטה כמו בהדגמה,"}</div>
            <div>{"הבנת?"}</div>
            <div>{"תלחץ על הכפתור הכתום להתחיל במשימה"}</div>
        </div>,
    start_rec2_high_gr_m:
        <span>
            {"תתחיל לקרוא בקול רם"}
        </span>,
    start_rec2_high_gr_f:
        <span>
            {"תתחילי לקרוא בקול רם"}
        </span>,
    start_rec_high_gr_m:
        <span>
            {"תתחיל לקרוא בקול רם מלמעלה ללמטה"}
        </span>,
    start_rec_high_gr_f:
        <span>
            {"תתחילי לקרוא בקול רם מלמעלה ללמטה"}
        </span>,
    start_perform_m:
        <div>
            {"יוצאים לדרך!"}
            <div>{"תלחץ על הכפתור הכתום כדי להתחיל"}</div>
            <div>{"וגם בכל פעם שתרצה לעבור לעמוד הבא"}</div>
        </div>,
    start_perform_f:
        <div>
            {"יוצאים לדרך!"}
            <div>{"תלחצי על הכפתור הכתום כדי להתחיל"}</div>
            <div>{"וגם בכל פעם שתרצי לעבור לעמוד הבא"}</div>
        </div>,
    check_mic_book_m:
        <div>
            {"עכשיו מחכה לך קטע שמספר על משהו מעניין."}
            <div>{"כדי להתחיל תלחץ על הכפתור הכתום"}</div>
            <div>{"ותקרא בקול ברור"}</div>
        </div>,
    check_mic_book_f:
        <div>
            {"עכשיו מחכה לך קטע שמספר על משהו מעניין."}
            <div>{"כדי להתחיל תלחצי על הכפתור הכתום"}</div>
            <div>{"ותקראי בקול ברור"}</div>
        </div>,
    questions_exam_m:
        <div>
            {"הנה כמה שאלות קצרות על מה שקראת,"}
            <div>{"תקרא בשקט ותלחץ על התשובה הנכונה "}</div>
            <div>{"כדי להתחיל תלחץ על הכפתור הכתום"}</div>
        </div>,
    questions_exam_f:
        <div>
            {"הנה כמה שאלות קצרות על מה שקראת,"}
            <div>{"תקראי בשקט ותלחצי על התשובה הנכונה "}</div>
            <div>{"כדי להתחיל תלחצי על הכפתור הכתום"}</div>
        </div>,
    check_mic_m:
        <div>
            {"אני רוצה להיות בטוח שאני שומע אותך"}
            <div>{"תלחץ על הכפתור הכתום "}</div>
            <div>{"ותאמר"}

                <b>{" אני רוצה להתחיל! "}</b>
            </div>
        </div>,
    check_mic_f:
        <div>
            {"אני רוצה להיות בטוח שאני שומע אותך"}
            <div>{"תלחצי על הכפתור הכתום "}</div>
            <div>{"ותאמרי"}

                <b>{" אני רוצה להתחיל! "}</b>
            </div>
        </div>


    // words_exm:
}

export default tooltips